import React from 'react';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './pendingContactCard.module.scss';
import EventParticipant from '../../PendingEvents/PendingEventCard/EventParticipant/EventParticipant';
import ProfilePicture from '../../ProfilePicture';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function PendingContactCard({ contact, trackCallback = null }) {
  const { agent, hours_since_assignment, profile_picture_url, display_hours } =
    contact;
  const toolTipText = Trans(translations, 'PendingAgo');
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');

  const contactData = [contact];
  const agentData = [agent];

  const handleClickRow = () => {
    const url = `${tokkoBrokerHost}/contact/${contact.id}/`;
    window.open(url, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box className={styles.pendingContactCard} onClick={handleClickRow}>
      <Box className={styles.leftContentContainer}>
        <ProfilePicture
          src={profile_picture_url}
          alt="contact picture"
          width={40}
        />
        <EventParticipant
          alignItems="flex-start"
          contacts={contactData}
          agents={agentData}
          trackCallback={trackCallback}
        />
      </Box>
      <Box className={styles.rightContentContainer}>
        <TimeStatusIndicator
          value={hours_since_assignment}
          displayTime={display_hours}
          toolTipText={toolTipText}
        />
      </Box>
    </Box>
  );
}

export default PendingContactCard;
